// Full 16-category ServiceNow curriculum taxonomy the user requested. The 5
// MVP categories (Platform Fundamentals, Developer, ITSM, AI & Automation,
// Certification Prep) are fully built into the day-locked 30-Day Challenge —
// each topic links to the specific Day that covers it. The remaining 11
// "Phase 2" categories (status: "library") are a browsable, non-gated Topic
// Library — each topic links to a standalone detail page with real content
// + a 2-question knowledge check (see backend/servicenow_extended_data.py).

export const SERVICENOW_CURRICULUM = [
  {
    category: "Platform Fundamentals", status: "available",
    topics: [
      { title: "Welcome to ServiceNow", day: 1 },
      { title: "ServiceNow Administration Fundamentals", day: 2 },
      { title: "ServiceNow Administration Advanced", day: 3 },
      { title: "ServiceNow Upgrade Essentials", day: null },
      { title: "Configuration Management Database (CMDB) Fundamentals", day: 4 },
      { title: "Common Service Data Model (CSDM) Fundamentals", day: 5 },
      { title: "Platform Security Fundamentals", day: 6 },
      { title: "Instance Security", day: 6 },
      { title: "Automated Test Framework (ATF)", day: 3 },
      { title: "ServiceNow Studio Overview", day: 7 },
    ],
  },
  {
    category: "Developer", status: "available",
    topics: [
      { title: "Application Development Fundamentals", day: 7 },
      { title: "Scripting in ServiceNow Fundamentals", day: 9 },
      { title: "JavaScript Fundamentals", day: 8 },
      { title: "Flow Designer Fundamentals", day: 10 },
      { title: "App Engine Fundamentals", day: 11 },
      { title: "App Engine Studio", day: 11 },
      { title: "IntegrationHub Fundamentals", day: 12 },
      { title: "REST API Integrations", day: 13 },
      { title: "SOAP API Integrations", day: 14 },
      { title: "Import Sets", day: 14 },
      { title: "Transform Maps", day: 14 },
      { title: "Source Control", day: 15 },
      { title: "Update Sets", day: 15 },
      { title: "Service Portal", day: 16 },
      { title: "UI Builder", day: 16 },
      { title: "Mobile Development", day: 16 },
    ],
  },
  {
    category: "IT Service Management (ITSM)", status: "available",
    topics: [
      { title: "ITSM Fundamentals", day: 17 },
      { title: "ITSM Implementation", day: 17 },
      { title: "Incident Management", day: 18 },
      { title: "Problem Management", day: 19 },
      { title: "Change Management", day: 19 },
      { title: "Request Management", day: 20 },
      { title: "Service Catalog", day: 20 },
      { title: "Knowledge Management", day: 21 },
      { title: "Service Level Management (SLM)", day: 21 },
      { title: "Service Operations Workspace (SOW) Essentials", day: 22 },
    ],
  },
  {
    category: "AI & Automation", status: "available",
    topics: [
      { title: "Introduction to Generative AI", day: 23 },
      { title: "Now Assist Essentials", day: 24 },
      { title: "Now Assist for Creator", day: 25 },
      { title: "Now Assist for ITSM", day: 25 },
      { title: "Now Assist for CSM", day: 25 },
      { title: "Now Assist for HRSD", day: null },
      { title: "Now Assist for ITOM", day: null },
      { title: "Now Assist for FSM", day: null },
      { title: "AI Agents: Administration", day: 26 },
      { title: "AI Agents: Build AI Agents", day: 26 },
      { title: "AI Agents: Configure AI Agents", day: 26 },
      { title: "Predictive Intelligence", day: 27 },
      { title: "AI Search", day: 27 },
    ],
  },
  {
    category: "Certification Preparation", status: "available",
    topics: [
      { title: "Certified System Administrator (CSA)", day: 28 },
      { title: "Certified Application Developer (CAD)", day: 28 },
      { title: "Certified Implementation Specialist (CIS)", day: 29 },
      { title: "Certified Technical Architect (CTA)", day: 29 },
    ],
  },
  {
    category: "IT Operations Management (ITOM)", status: "library",
    topics: [
      { title: "Discovery", slug: "itom-discovery" }, { title: "Service Mapping", slug: "itom-service-mapping" }, { title: "Event Management", slug: "itom-event-management" },
      { title: "Cloud Management", slug: "itom-cloud-management" }, { title: "Operational Intelligence", slug: "itom-operational-intelligence" }, { title: "Health Log Analytics", slug: "itom-health-log-analytics" },
    ],
  },
  {
    category: "IT Asset Management (ITAM)", status: "library",
    topics: [
      { title: "Hardware Asset Management (HAM) Fundamentals", slug: "itam-ham-fundamentals" }, { title: "HAM Implementation", slug: "itam-ham-implementation" },
      { title: "Software Asset Management (SAM) Fundamentals", slug: "itam-sam-fundamentals" }, { title: "SAM Implementation", slug: "itam-sam-implementation" },
      { title: "Enterprise Asset Management (EAM)", slug: "itam-eam" },
    ],
  },
  {
    category: "Customer Service Management (CSM)", status: "library",
    topics: [
      { title: "Customer Service Management Fundamentals", slug: "csm-fundamentals" }, { title: "Customer Service Management Implementation", slug: "csm-implementation" },
      { title: "Case Management", slug: "csm-case-management" }, { title: "Omnichannel", slug: "csm-omnichannel" }, { title: "Customer Portal", slug: "csm-customer-portal" },
    ],
  },
  {
    category: "HR Service Delivery (HRSD)", status: "library",
    topics: [
      { title: "Human Resources Fundamentals", slug: "hrsd-fundamentals" }, { title: "Human Resources Implementation", slug: "hrsd-implementation" },
      { title: "Employee Center", slug: "hrsd-employee-center" }, { title: "Employee Journey Management", slug: "hrsd-employee-journey" },
    ],
  },
  {
    category: "Security & Risk", status: "library",
    topics: [
      { title: "Security Operations Fundamentals", slug: "secops-fundamentals" }, { title: "Security Incident Response", slug: "secops-incident-response" },
      { title: "Vulnerability Response", slug: "secops-vulnerability-response" }, { title: "Threat Intelligence", slug: "secops-threat-intelligence" },
      { title: "Integrated Risk Management (IRM) Fundamentals", slug: "irm-fundamentals" }, { title: "IRM Implementation", slug: "irm-implementation" },
      { title: "Governance, Risk and Compliance (GRC)", slug: "grc" },
    ],
  },
  {
    category: "Strategic Portfolio Management (SPM)", status: "library",
    topics: [
      { title: "Strategic Portfolio Management Fundamentals", slug: "spm-fundamentals" }, { title: "SPM Implementation", slug: "spm-implementation" },
      { title: "Demand Management", slug: "spm-demand-management" }, { title: "Project Portfolio Management", slug: "spm-ppm" },
      { title: "Agile Development", slug: "spm-agile-development" }, { title: "Resource Management", slug: "spm-resource-management" },
    ],
  },
  {
    category: "Analytics", status: "library",
    topics: [
      { title: "Reporting Fundamentals", slug: "analytics-reporting-fundamentals" }, { title: "Platform Analytics Fundamentals", slug: "analytics-platform-fundamentals" },
      { title: "Platform Analytics Advanced", slug: "analytics-platform-advanced" }, { title: "Performance Analytics Essentials", slug: "analytics-performance-essentials" }, { title: "Dashboards", slug: "analytics-dashboards" },
    ],
  },
  {
    category: "Field Service Management", status: "library",
    topics: [
      { title: "Field Service Management Fundamentals", slug: "fsm-fundamentals" }, { title: "Field Service Management Implementation", slug: "fsm-implementation" },
      { title: "Now Assist for FSM Essentials", slug: "fsm-now-assist" },
    ],
  },
  {
    category: "Industry Products", status: "library",
    topics: [
      { title: "Telecommunications Service Management (TSM)", slug: "industry-tsm" }, { title: "Financial Services Operations (FSO)", slug: "industry-fso" },
      { title: "Public Sector Digital Services (PSDS)", slug: "industry-psds" }, { title: "Legal Service Delivery (LSD)", slug: "industry-lsd" },
      { title: "Workplace Service Delivery", slug: "industry-workplace-service-delivery" }, { title: "Manufacturing Commercial Operations", slug: "industry-manufacturing" }, { title: "Clinical Device Management", slug: "industry-clinical-device" },
    ],
  },
  {
    category: "Integrations", status: "library",
    topics: [
      { title: "MID Server", slug: "integrations-mid-server" }, { title: "LDAP Integration", slug: "integrations-ldap" }, { title: "SSO Integration", slug: "integrations-sso" },
      { title: "Email Integration", slug: "integrations-email" }, { title: "Service Graph Connector", slug: "integrations-service-graph-connector" }, { title: "IntegrationHub ETL", slug: "integrations-hub-etl" },
    ],
  },
  {
    category: "Career Learning Paths", status: "library",
    topics: [
      { title: "System Administrator", slug: "career-system-administrator" }, { title: "Application Developer", slug: "career-application-developer" }, { title: "Implementer", slug: "career-implementer" },
      { title: "Business Process Analyst", slug: "career-business-process-analyst" }, { title: "Technical Project Manager", slug: "career-technical-project-manager" }, { title: "Platform Owner", slug: "career-platform-owner" },
    ],
  },
];
